import { render, staticRenderFns } from "./PengaturanAkunPenelitiKeamanan.vue?vue&type=template&id=659d2f14&scoped=true&"
import script from "./PengaturanAkunPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./PengaturanAkunPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d2f14",
  null
  
)

export default component.exports